export interface HttpExceptionBody extends Record<string, unknown> {
  message?: string | string[];
}

const DEFAULT_ERROR_MESSAGE = 'Request failed';

const getMessageFromBody = (body?: HttpExceptionBody | null | string) => {
  if (typeof body === 'string') {
    const trimmedBody = body.trim();
    return trimmedBody.length > 0 ? trimmedBody : undefined;
  }

  if (!body) {
    return undefined;
  }

  if (Array.isArray(body.message)) {
    const joinedMessage = body.message.filter(Boolean).join('\n').trim();
    return joinedMessage.length > 0 ? joinedMessage : undefined;
  }

  if (typeof body.message === 'string') {
    const trimmedMessage = body.message.trim();
    return trimmedMessage.length > 0 ? trimmedMessage : undefined;
  }

  return undefined;
};

const getFallbackMessage = (response: Response) => {
  const statusText = response.statusText.trim();
  if (statusText.length > 0) {
    return `${response.status} ${statusText}`;
  }

  return DEFAULT_ERROR_MESSAGE;
};

export class HttpException extends Error {
  public readonly body: HttpExceptionBody;
  public readonly response: Response;

  constructor(response: Response, body?: HttpExceptionBody | null | string) {
    const resolvedMessage = getMessageFromBody(body) || getFallbackMessage(response);

    super(resolvedMessage);
    this.name = 'HttpException';
    this.response = response;
    this.body =
      typeof body === 'string'
        ? { message: resolvedMessage }
        : {
            ...(body || {}),
            message: getMessageFromBody(body) || resolvedMessage,
          };

    Object.setPrototypeOf(this, HttpException.prototype);
  }
}
